var userAgent = require('../internals/engine-user-agent');
var global = require('../internals/global');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/engine-is-ios-pebble.js
// module id = 545
// module chunks = 0